module.exports = __webpack_public_path__ + "static/media/hotel-nicanor.0bc40527.jpg";